import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";

interface UseReviewSectionLeadProps {
  privateCompanyLeadId?: string
  state?: string
  section: string,
  payload?: any,
  onSuccess: () => void
  onError: () => void
}

const useReviewSectionLead = ({ privateCompanyLeadId, state, section, payload, onSuccess, onError }: UseReviewSectionLeadProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['reviewSectionLead'],
    mutationFn: async (data?: { description?: string }) => {
      const private_company_lead = {
        [section]: {
          last_review_attributes: {
            state,
            description: data?.description
          },
          ...payload
        }
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}

export default useReviewSectionLead